(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kk-at-a-glance"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--aag');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-aag-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-aag__item--visible');
      }, 300 + (i * 100));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-compare"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--comp');
  if (!sectionEl) return;
  var rows = sectionEl.querySelectorAll('[data-kk-comp-row]');
  if (!rows.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealRows() {
    rows.forEach(function(row, i) {
      setTimeout(function() {
        row.classList.add('kk-comp__row--visible');
      }, 300 + (i * 100));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealRows();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealRows();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-content-block"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.kk-section--cb');
  if (!sections.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        setTimeout(function() { el.classList.add('kk-cb--animated'); }, 1000);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 });
  sections.forEach(function(s) { observer.observe(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-cross-sell"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--cross');
  if (!sectionEl) return;
  var cards = sectionEl.querySelectorAll('[data-kk-cross-card]');
  if (!cards.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* === Staggered Reveal: Reagiert auf globalen Scroll-Reveal (kk-visible) === */
  if (prefersReduced) {
    /* Sofort sichtbar, CSS handled via !important */
  } else {
    /* Pruefe ob Section schon sichtbar (z.B. above the fold oder Seitenrueckkehr) */
    if (sectionEl.classList.contains('kk-visible')) {
      revealCards();
    } else {
      /* MutationObserver: Wartet bis der globale Scroll-Reveal kk-visible setzt */
      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (sectionEl.classList.contains('kk-visible')) {
            revealCards();
            mo.disconnect();
            return;
          }
        }
      });
      mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function revealCards() {
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-cross__card--visible');
      }, 400 + (i * 120));
    });
  }

  /* === Quick-Add mit Erfolgs-Feedback === */
  var forms = sectionEl.querySelectorAll('[data-kk-cross-form]');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.kk-cross__add-btn');
      if (btn.classList.contains('kk-cross__add-btn--success')) return;

      var body = 'id=' + encodeURIComponent(form.querySelector('[name="id"]').value) + '&quantity=1';

      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function(res) {
        if (res.ok) {
          /* Checkmark anzeigen */
          btn.classList.add('kk-cross__add-btn--success');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

          /* Cart-Counter aktualisieren (Impact Theme) */
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } catch(err) {}

          /* Nach 2s zuruecksetzen */
          setTimeout(function() {
            btn.classList.remove('kk-cross__add-btn--success');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
          }, 2000);
        }
      }).catch(function() {
        /* Fallback: Normales Form-Submit */
        form.submit();
      });
    });
  });

  /* === Mobile: Scroll-Fade am Ende ausblenden === */
  var grid = sectionEl.querySelector('.kk-cross__grid');
  var wrap = sectionEl.querySelector('.kk-cross__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-cross__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-food-compare"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--food');
  if (!sectionEl) return;
  var parts = sectionEl.querySelectorAll('[data-kk-food-part]');
  if (!parts.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  /* Drei Akte: Food (300ms) -> Divider (500ms) -> Hero (650ms) */
  var delays = [300, 500, 650];

  function revealParts() {
    parts.forEach(function(part, i) {
      setTimeout(function() {
        part.classList.add('kk-food--visible');
      }, delays[i] || 300 + (i * 150));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealParts();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealParts();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-general-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.kk-section--gfaq .kk-gfaq__item');
  if (!items.length) return;
  items.forEach(function(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    // first_open (server-gerendert): sofort sichtbar, kein Flash
    if (details.open) {
      summary.setAttribute('aria-expanded', 'true');
      details.classList.add('kk-gfaq__item--reveal');
    }

    // Native <details> oeffnet/schliesst die Hoehe SOFORT (1 Reflow, kein Per-Frame-Layout).
    // 'toggle' synct aria + blendet den Inhalt per GPU ein (--reveal 2 Frames spaeter).
    details.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (details.open) details.classList.add('kk-gfaq__item--reveal');
          });
        });
      } else {
        details.classList.remove('kk-gfaq__item--reveal');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-good-to-know"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* --- Scoped Table Scroll Wrapper --- */
  var sectionEl = document.querySelector('.kk-section--gtk');
  var root = sectionEl ? sectionEl.querySelector('.kk-gtk') : null;
  if (!root) return;

  requestAnimationFrame(function() {
    var tables = root.querySelectorAll('.kk-gtk__content table');
    tables.forEach(function(table) {
      if (table.parentNode.classList.contains('kk-gtk__table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'kk-gtk__table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  });

  /* --- Article Reveal (identisches Pattern wie kk-product-compare) --- */
  var articles = sectionEl.querySelectorAll('[data-kk-gtk-article]');
  if (!articles.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealArticles() {
    articles.forEach(function(article) {
      article.classList.add('kk-gtk__article--visible');
    });
  }

  /* Customizer: sofort sichtbar */
  if (window.Shopify && window.Shopify.designMode) {
    revealArticles();
    return;
  }

  /* Standard: warte auf kk-visible vom Custom Liquid Block */
  if (sectionEl.classList.contains('kk-visible')) {
    revealArticles();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealArticles();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-nutrition"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--nut');
  if (!sectionEl) return;
  var cards = sectionEl.querySelectorAll('[data-kk-nut-card]');
  if (!cards.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealCards() {
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-nut__card--visible');
      }, 300 + (i * 200));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealCards();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealCards();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-product-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.kk-section--faq .kk-faq__item');
  if (!items.length) return;
  items.forEach(function(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    // first_open (server-gerendert): sofort sichtbar, kein Flash
    if (details.open) {
      summary.setAttribute('aria-expanded', 'true');
      details.classList.add('kk-faq__item--reveal');
    }

    // Native <details> oeffnet/schliesst die Hoehe SOFORT (1 Reflow, kein Per-Frame-Layout).
    // 'toggle' synct aria + blendet den Inhalt per GPU ein (--reveal 2 Frames spaeter).
    details.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            if (details.open) details.classList.add('kk-faq__item--reveal');
          });
        });
      } else {
        details.classList.remove('kk-faq__item--reveal');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-quality"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--quality');
  if (!sectionEl) return;
  var parts = sectionEl.querySelectorAll('[data-kk-quality-part]');
  if (!parts.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealParts() {
    parts.forEach(function(part, i) {
      setTimeout(function() {
        part.classList.add('kk-quality--visible');
      }, 300 + (i * 250));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealParts();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealParts();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--rev');
  if (!sectionEl) return;

  var trustBar = sectionEl.querySelector('[data-kk-rev-trust]');
  var cards = sectionEl.querySelectorAll('[data-kk-rev-card]');
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReduced) return;

  function revealSequence() {
    /* Trust-Bar zuerst (300ms nach Section-Reveal) */
    if (trustBar) {
      setTimeout(function() {
        trustBar.classList.add('kk-rev__trust--visible');
      }, 300);
    }

    /* Cards gestaffelt (500ms Basis + 120ms pro Card) */
    cards.forEach(function(card, i) {
      setTimeout(function() {
        card.classList.add('kk-rev__item--visible');
      }, 500 + (i * 120));
    });
  }

  /* Auf globalen Scroll-Reveal reagieren (kk-visible) */
  if (sectionEl.classList.contains('kk-visible')) {
    revealSequence();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealSequence();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* Mobile: Scroll-Fade am Ende ausblenden */
  var grid = sectionEl.querySelector('.kk-rev__grid');
  var wrap = sectionEl.querySelector('.kk-rev__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-rev__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-trust-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--trust');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-trust-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-trust__item--visible');
      }, 300 + (i * 130));
    });

    /* v2.4.2: Strich fadet mit der zweiten Stimme, Punkte + Label als Abschluss */
    var rule = sectionEl.querySelector('.kk-trust__rule');
    var dots = sectionEl.querySelector('.kk-trust__dots');
    var label = sectionEl.querySelector('.kk-trust__label');
    var tail = 300 + (items.length * 130);
    if (rule) {
      setTimeout(function() { rule.classList.add('kk-trust__fade-in'); }, 430);
    }
    [dots, label].forEach(function(el) {
      if (el) {
        setTimeout(function() { el.classList.add('kk-trust__fade-in'); }, tail);
      }
    });
  }

  /* Auf den globalen Scroll-Reveal (kk-visible, Custom-Liquid-Block v9) reagieren */
  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kk-usps"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionEl = document.querySelector('.kk-section--usps');
  if (!sectionEl) return;
  var items = sectionEl.querySelectorAll('[data-kk-usps-item]');
  if (!items.length) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  function revealItems() {
    items.forEach(function(item, i) {
      setTimeout(function() {
        item.classList.add('kk-usps__item--visible');
      }, 300 + (i * 80));
    });
  }

  if (sectionEl.classList.contains('kk-visible')) {
    revealItems();
  } else {
    var mo = new MutationObserver(function() {
      if (sectionEl.classList.contains('kk-visible')) {
        revealItems();
        mo.disconnect();
      }
    });
    mo.observe(sectionEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* Mobile: Scroll-Fade am Ende ausblenden */
  var grid = sectionEl.querySelector('.kk-usps__grid');
  var wrap = sectionEl.querySelector('.kk-usps__grid-wrap');
  if (wrap && grid && window.innerWidth <= 749) {
    grid.addEventListener('scroll', function() {
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      wrap.classList.toggle('kk-usps__grid-wrap--scrolled-end', atEnd);
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
